import axios from 'axios';
import { BASE_URL, CUSTOMER } from './endpoints';

const CUSTOMER_BASE_URL = `${BASE_URL}${CUSTOMER.BASE}`;

export const fetchAllCustomers = (data: any) => {
  return axios.post(`${CUSTOMER_BASE_URL}/filter`, data);
};
